import { ROUTES } from "@/routes";

const routePermissions = [
  {
    path: ROUTES.ADMIN_CLIENTS,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_CLIENT_DETAIL,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_BUILDING_DETAIL,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_BUILDING_CARD,
    permission: "clients",
  },
  {
    path: ROUTES.ADMIN_ADMINS,
    permission: "admins",
  },
  {
    path: ROUTES.ADMIN_ADMIN_DETAIL,
    permission: "admins",
  },
  {
    path: ROUTES.ADMIN_FREQUENTLY_ASKED_QUESTIONS,
    permission: "faqs",
  },
  {
    path: ROUTES.ADMIN_FREQUENTLY_ASKED_QUESTIONS_FORM,
    permission: "faqs",
  },
  {
    path: ROUTES.ADMIN_DELETED_ITEMS,
    permission: "deleted-items",
  },
] as const;

export function findRoutePermission(pathname: string) {
  return routePermissions.find((route) => route.path === pathname)?.permission;
}
